
const HistoricalDownload = () => { 
    return(
        <section>
            <div>
                <h1>Download</h1>
            </div>
        </section>
    )
}

export default HistoricalDownload